import { FC, SVGProps } from 'react';

export const ArrowRightIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns='http://www.w3.org/2000/svg' width='24' height='25' viewBox='0 0 24 25' fill='none' {...props}>
		<path
			d='M12 1.25C5.787 1.25 0.75 6.287 0.75 12.5C0.75 18.713 5.787 23.75 12 23.75C18.213 23.75 23.25 18.713 23.25 12.5C23.25 6.287 18.213 1.25 12 1.25ZM12.6349 18.5V14.5355H5.625V10.6786H12.6349V6.5L18.375 12.5L12.6349 18.5Z'
			fill='currentColor'
			fillOpacity='0.4'
		/>
	</svg>
);
